<ng-container [formGroup]="currentForm">
  <label class="text-lg text-blue-800 col-span-3">
    {{ label }}
  </label>
  <nz-select
    class="col-span-9"
    [ngClass]="{ 'border border-blue-600': !readOnly }"
    [nzBorderless]="!readOnly"
    [nzShowArrow]="!readOnly"
    [formControlName]="attribute"
  >
    @for (option of selectOptions; track option) {
      <nz-option
        [nzValue]="option[valueKey]"
        [nzLabel]="option[labelKey]"
        [nzDisabled]="readOnly"
      ></nz-option>
    }
  </nz-select>
</ng-container>
